export const getCompanyLogo = (src: string): string => {
  if (src.startsWith("/img/static")) return src;

  return `${process.env.API_URL}/uploads/companies/logos/${src}`;
};

export const getCourseThumbnail = (src: string): string => {
  if (src.startsWith("/img/static")) return src;

  return `${process.env.API_URL}/uploads/educational-center/internal-training/courses/thumbnails/${src}`;
};
